@if (steps().length > 0) {
    <div class="steps" [class.steps--expanded]="expanded()">
        <button
            type="button"
            class="steps__header"
            [attr.aria-expanded]="expanded()"
            (click)="toggle()"
        >
            <i class="fa-solid fa-diagram-project steps__header-icon"></i>
            <span class="steps__heading">{{ heading() }}</span>
            @if (!expanded()) {
                <span class="steps__count">{{ displaySteps().length }}</span>
            }
            <i
                class="fa-solid steps__chevron"
                [class.fa-chevron-down]="!expanded()"
                [class.fa-chevron-up]="expanded()"
            ></i>
            @if (expanded() ? expandedLabel() : collapsedLabel(); as toggleLabel) {
                <span class="steps__toggle-label">({{ toggleLabel }})</span>
            }
        </button>

        @if (expanded()) {
            <ul class="steps__list">
                @for (step of renderedSteps(); track step.name) {
                    <li
                        class="steps__item"
                        [class.steps__item--running]="step.running"
                    >
                        <span class="steps__badge">
                            <i class="fa-solid {{ step.icon }}"></i>
                        </span>
                        <span class="steps__body">
                            <span class="steps__row">
                                <span class="steps__message">{{ step.text }}</span>
                                @if (step.running) {
                                    <span
                                        class="steps__spinner"
                                        aria-hidden="true"
                                    ></span>
                                } @else if (step.elapsedMs !== null) {
                                    <span class="steps__elapsed">{{
                                        formatElapsed(step.elapsedMs)
                                    }}</span>
                                }
                            </span>
                            @if (
                                step.endMessage &&
                                step.endMessage !== step.message
                            ) {
                                <span class="steps__submessage">{{
                                    step.endMessage
                                }}</span>
                            }
                        </span>
                    </li>
                }
            </ul>
        }
    </div>
}
